export enum HistoricityType {
Daily,
Dimentional,
Fixed,
}
